import type { AuthUserProfile } from '../features/auth/types/auth';

/**
 * Must match backend `inviteAdminUser` placeholders (`INVITE_GIVEN` / `INVITE_FAMILY`).
 */
const INVITE_PLACEHOLDER_FIRST = 'Invited';
const INVITE_PLACEHOLDER_LAST = 'User';

/**
 * Admin-invited users are created with placeholder names until they complete profile.
 */
export function hasInvitePlaceholderName(
  user: Pick<AuthUserProfile, 'firstName' | 'lastName'> | undefined,
): boolean {
  if (!user) return false;
  return (
    (user.firstName?.trim() ?? '') === INVITE_PLACEHOLDER_FIRST &&
    (user.lastName?.trim() ?? '') === INVITE_PLACEHOLDER_LAST
  );
}
